import { useEffect, useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DonorService } from "../../Services/Donor.Service";
import { UserService } from "../../Services/User.service";

const MyAddress = ({ userData, addressListRef, handleEditAddress, handleDeleteAddress  ,setToastMessage, setToastVariant, setShowToast, setLoading}) => {
    const navigate = useNavigate();
    console.log("User Data in MyAddress:", userData.addresses);

    const [selectedAddresses, setSelectedAddresses] = useState([]);
    const [errorMessage, setErrorMessage] = useState(""); 
    useEffect(() => {
        if (userData.addresses) {
            setSelectedAddresses(
                userData.addresses?.filter(a => a.status === true).map(a => a.address_id) || []
            );
        }
        
    }, [userData.addresses]);


     const handleCheckboxChange = (addressId) => {
        setSelectedAddresses(prev =>
            prev.includes(addressId)
                ? prev.filter(id => id !== addressId)
                : [...prev, addressId]
        );
         if (errorMessage) setErrorMessage(""); 
    };


    const handleSubmit = async () => {
        if (selectedAddresses.length === 0) {  // Validation check
            setErrorMessage("Please select at least one address.");
            return;
        }

        setLoading(true);

        const payload = {
            user_id: userData?.id,
            address_id: selectedAddresses
        };

        try {
            const response = await UserService.updateAddressStatus(payload);

            if (response.success) {
                setToastMessage("Address selection updated successfully");
                setToastVariant("success");
            } else {
                setToastMessage(response.message || "Failed to update");
                setToastVariant("danger");
            }
        } catch (e) {
            console.error(e);
            setToastMessage("Something went wrong");
            setToastVariant("danger");
        }
        
        setShowToast(true);
        setLoading(false);
    }

    return (
        <div>
            <div className="el-bg-table el-super-admin mt-3" ref={addressListRef}>
                <Accordion alwaysOpen defaultActiveKey={["2"]} flush>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header className="cursor-pointer">
                            <div>
                                <div><b>My Addresses</b></div>
                                <div><p>Select the location(s) where you would like to be matched with jobs.</p></div>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <container className="el-property-details-card-content">
                                <Row>
                                    <Col md={12} className="mx-fit-content">
                                        <div className="row mt-2">
                                            <ul className="ms-3">
                                                {/* // checked={values.selectedAddresses.includes(address.address_id)} */}
                                                {userData.addresses?.length === 0 && (
                                                    <>
                                                    No addresses available
                                                    </>
                                                )}
                                                {userData.addresses?.map((address, index) => (
                                                    <li key={index} className="d-flex align-items-center form-check">
                                                        <input
                                                            id={`chk_${address.address_id}`}
                                                            type="checkbox"
                                                            className="form-check-input dashboard-card-count"
                                                            checked={selectedAddresses.includes(address.address_id)}
                                                            onChange={() => handleCheckboxChange(address.address_id)}
                                                        />

                                                        <label htmlFor={`chk_${address.address_id}`} className="ms-3 form-check-label dashboard-card-count">
                                                            <span>{`${address.type}, ${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.postal_code}.`}</span>
                                                        </label>
                                                        <a className="back-link ms-3 font-size-16" onClick={() => handleEditAddress(address)}>(Edit)</a>
                                                        <a className="back-link text-danger font-size-16" onClick={() => handleDeleteAddress(address)}>(Delete)</a>
                                                    </li>
                                                ))}
                                               {errorMessage && (
                                                    <div className="text-danger mt-2 ms-3">{errorMessage}</div>
                                                )}

                                            </ul>

                                            <button className="el-main-button me-3 ms-3" onClick={() => { navigate('add-address') }}  ><span> <i className="el-icon-add"></i> Add a Location to donate</span></button>
                                        </div>
                                    </Col>
                                </Row>
                            </container>
                        </Accordion.Body>
                    </Accordion.Item>

                </Accordion>
                <div className="d-flex align-items-center mt-3">
                <button type="submit" onClick={()=>{handleSubmit()}}  className="el-main-button me-3">
                    <span>Save Changes</span>
                </button>
                </div>

            </div>
        </div>
    );
}
export default MyAddress;